import React, { useEffect, useState } from "react";
import signinLogo from "../../assets/images/login/signin-logo.png";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosInstance } from "../../axiosInstance";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./ResetPassword.css";

const loginSchema = Yup.object({
  new_password: Yup.string().required("New password is required"),
  confirm_password: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("new_password"), null], "Passwords must match"),
});

export function ResetPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  // const otpToken = localStorage.getItem("otp_token");
  const otpToken = localStorage.getItem("token");

  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      setServerError("");

      const payload = {
        new_password: values.new_password.trim(),
        confirm_password: values.confirm_password.trim(),
      };

      console.log("👉 Payload before sending to API:", payload);
      try {
        const response = await axiosInstance.post(`/reset-password/`, payload, {
          headers: {
            Authorization: `Bearer ${otpToken}`,
          },
        });
        console.log(" Response from API:", response);

        if (response.data.status === "success") {
          localStorage.removeItem("token");
          localStorage.removeItem("mobile_no");

          navigate("/login");
        } else {
          setServerError(response.data.message || "Login failed");
        }
      } catch (error) {
        setServerError(
          error.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="signin-container">
      <div className="signin-left">
        <div>
          <div className="signin-logo">
            <img src={signinLogo} />
          </div>
          <div className="signin-lefttext">
            Welcome to Go Mak Referral — your platform to manage medicine
            deliveries with speed, security, and reliability. Together, we
            ensure healthcare providers get the medicines they need, on time.
          </div>
        </div>
      </div>
      <div className="signin-right">
        <div>
          <form className="signin-formContainer" onSubmit={formik.handleSubmit}>
            <div className="signin-title">Reset Password</div>
            {/* <div className="signin-subtitle">Welcome to Go Mak Admin</div> */}
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span>New Password
              </label>

              {/* <div>
                <input
                  type="password"
                  placeholder="Enter new password"
                  name="new_password"
                  value={formik.values.new_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.new_password && formik.errors.new_password
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.new_password && formik.errors.new_password && (
                  <div className="error-message-signIn">
                    {formik.errors.new_password}
                  </div>
                )}
              </div> */}
              <div className="password-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  name="new_password"
                  value={formik.values.new_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.new_password && formik.errors.new_password
                      ? "input-error-signIn"
                      : ""
                  }
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {formik.touched.new_password && formik.errors.new_password && (
                <div className="error-message-signIn">
                  {formik.errors.new_password}
                </div>
              )}
            </div>
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span>Confirm Password
              </label>
              {/* <div>
                <input
                  type="password"
                  placeholder="Enter confirm password"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.confirm_password &&
                    formik.errors.confirm_password
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.confirm_password &&
                  formik.errors.confirm_password && (
                    <div className="error-message-signIn">
                      {formik.errors.confirm_password}
                    </div>
                  )}
              </div> */}
              <div className="password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Enter confirm password"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.confirm_password &&
                    formik.errors.confirm_password
                      ? "input-error-signIn"
                      : ""
                  }
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {formik.touched.confirm_password &&
                formik.errors.confirm_password && (
                  <div className="error-message-signIn">
                    {formik.errors.confirm_password}
                  </div>
                )}
              {serverError && (
                <div
                  className="error-message-signIn"
                  style={{ marginBottom: "10px" }}
                >
                  {serverError}
                </div>
              )}
            </div>
            <div className="btnLogin">
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Submiting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
